import { render } from "./ProsesIsiGaleri.vue?vue&type=template&id=09c5d816"
import script from "./ProsesIsiGaleri.vue?vue&type=script&lang=js"
export * from "./ProsesIsiGaleri.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__